"use client";

import React from "react";
import { Quote, Star } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * RealEstateWebsite — Section 7: Testimonial
 * Drop-in für: src/pages/RealEstateWebsite/sections/ContractorSuccessStories.tsx
 *
 * Andreas Müller (Vista Properties Lausanne) — passend zur Demo-Site.
 */

export default function ContractorSuccessStories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section className="bg-secondary py-20 md:py-24">
      <div ref={ref} className={`max-w-3xl mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <Quote className="w-10 h-10 text-primary/20 mx-auto mb-6 rotate-180" strokeWidth={1.5} />

        <p className="text-2xl md:text-3xl font-medium italic text-foreground leading-relaxed mb-8">
          «Vor PAGEMAKER24 waren wir nur auf Immo-Portalen austauschbar. Jetzt
          haben wir unsere eigene Marke und bekommen direkt Anfragen über die
          Website.»
        </p>

        <div className="flex items-center justify-center gap-1 text-primary mb-4">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" />)}
        </div>

        <div>
          <span className="font-bold text-foreground">Andreas Müller</span>
          <span className="text-muted-foreground mx-2">·</span>
          <span className="text-muted-foreground">
            Immobilienbüro, Lausanne
          </span>
        </div>
      </div>
    </section>;
}